module.exports = {
  label: {
    searchName: 'Search for name…',
    enterMessage: 'Enter Message...',
    buttons: {
      backLogin: 'Back to Login'
    }
  }
}